/**
 * Категорії множини — за CLDR через `Intl.PluralRules`.
 *
 * Раніше правила були написані руками для двох груп (uk/ru і en/de). З 15
 * мовами так не можна: польська, чеська, романські мови мають власні правила,
 * а `Intl.PluralRules` знає їх усі й однаково працює в браузерах і в Node.
 */
export type PluralCategory = 'one' | 'few' | 'many' | 'other';

export type PluralForms = Partial<Record<PluralCategory, string>> & { other: string };

const rules = new Map<string, Intl.PluralRules>();

export function pluralCategory(locale: string, n: number): PluralCategory {
  let rule = rules.get(locale);
  if (rule === undefined) {
    rule = new Intl.PluralRules(locale);
    rules.set(locale, rule);
  }
  const category = rule.select(n);
  // `zero` і `two` у наших мовах не трапляються; якщо трапляться — це other.
  return category === 'one' || category === 'few' || category === 'many' ? category : 'other';
}

export function selectPlural(locale: string, forms: PluralForms, n: number): string {
  const category = pluralCategory(locale, n);
  return forms[category] ?? forms.other;
}
